
//Initialising the data Layer in the Reducer 
export const initialState = {
    basket: [],
};



//Reducer is a kind of listner , listens for action and based on action modifies our data layer : TAkes Input(Action) -> returns the modified state 
//We are USing Both Reducer(Club the logic behind similar state) And Context (To Make use of reducer function Every COmponents in the APP )  to create DATA LAYER

const reducer = (state, action) => {

    switch (action.type) {
        case 'ADD_TO_BASKET':
            const proIndex = state.basket.findIndex((el) => el.id === action.item.id)
            if (state.basket.length === 0 || proIndex === -1) {
                console.log("First ADd to cart");
                return {
                    ...state,
                    basket: [...state.basket, action.item], //adds new item to global data layer
                };
            }
            else {
                console.log("Repeat  ADd to cart");
                //console.log("b",state.basket[proIndex].qty);
                state.basket[proIndex].qty = ++state.basket[proIndex].qty;
                //console.log(state.basket[proIndex].qty);
                return {
                    ...state,
                    basket: state.basket

                }
            };
            break;

        case 'REMOVE_FROM_BASKET':
            const proInd = state.basket.findIndex(el => el.id === action.id);
            if (proInd === -1) {
                console.warn("Sorry! No Such Product Found In your cart");
            }
            else {
                // const newBasket = state.basket.splice(proInd, 1);  if we wanted to delete that index
                if (state.basket[proInd].qty < 2) { // qty = -1,0,1
                    state.basket.splice(proInd, 1);
                    console.log("last", state.basket);
                }
                else {
                    state.basket[proInd].qty -= 1;

                }

            };
            return {
                ...state,
                basket: state.basket
            };
            break;




        default:
            return state;


    }
}

export default reducer;